var HelloRetailProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
    const section = this.closest('.shopify-section');
    const sectionId = section.id;
    const key = this.getAttribute('data-key');
    const collectionUrl = this.getAttribute('data-url');
    window.hrRecommendations = window.hrRecommendations || {};
    window.hrRecommendations[sectionId] = {
      'key': key,
      'format': 'json',
      'context': {
        'urls': [collectionUrl]
      }
    }
  }
};
if (!window.customElements.get('hr-product-recommendations')) {
  window.customElements.define('hr-product-recommendations', HelloRetailProductRecommendations);
}
